import React from "react";
import "consignment-stock/css/index.css";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

type Props = {
  error: FetchBaseQueryError | SerializedError;
};

const Error: React.FC<Props> = ({ error }) => {
  console.log("error comp", error);
  return (
    <>
      {JSON.stringify(
        "data" in error && typeof error.data === "object" ? (error.data as any)?.message : null,
      )}
      {JSON.stringify(
        "data" in error && typeof error.data === "object" ? (error.data as any)?.error : null,
      )}
    </>
  );
};

export default Error;
